import * as React from 'react';
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { BadgeBoxSx, FlexBoxInline, ListItemSx, SecondaryBtnSx } from '../../@shared/templates';
import { Palette, Sizes } from '../../@shared/palette';
import { UserAvatar } from '../../components/UserAvatar';
import { User } from '../../@shared/Models/Models';

export type SubscriptionUserItemType = {
  user: User;
  onRemoveAccess: (id: string) => void;
  isOwner: boolean;
}

export const SubscriptionUserItem = (props: SubscriptionUserItemType) => {
  return <Box sx={{ ...FlexBoxInline, ...ListItemSx, justifyContent: "space-between", marginBottom: "0" }}>
    <Box sx={{ ...FlexBoxInline, gap: "10px" }}>
      <UserAvatar user={props.user} size={32} />
      <Typography sx={{
        fontSize: Sizes.textPrimary,
        color: Palette.textColorPrimary,
      }}>{props.user.email}</Typography>
      {props.isOwner && <Box sx={{ ...BadgeBoxSx, background: Palette.btnPrimary }}>
        <Typography sx={{ fontSize: Sizes.textSecondary, color: Palette.textColorPrimaryContrast }}>Owner</Typography>
      </Box>}
    </Box>
    <Box sx={FlexBoxInline}>
      {!props.isOwner && <Tooltip title={"Unassign"} placement="bottom" arrow>
        <IconButton sx={{ ...SecondaryBtnSx, p: "5px", border: "none" }} aria-label="delete" onClick={() => props.onRemoveAccess(props.user.id)}>
          <ClearIcon sx={{ fontSize: Sizes.icon }} />
        </IconButton>
      </Tooltip>}
    </Box>
  </Box>

}